import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ConfigureTabProps {
  formData: any;
  onFormChange: (field: string, value: any) => void;
}

const fieldClass =
  "h-11 !h-[44px] rounded-xl border border-[#E5E7EB] bg-white text-[#0F172A] placeholder:text-[#94A3B8] focus-visible:border-[#2563EB] focus-visible:ring-[#2563EB]/20 dark:border-[#3F3F46] dark:bg-[#27272A] dark:text-[#FAFAFA] dark:placeholder:text-[#71717A] dark:focus-visible:border-[#60A5FA]";

const ConfigureTab: React.FC<ConfigureTabProps> = ({ formData, onFormChange }) => {
  const handleTimeValueChange = (value: string) => {
    onFormChange('response_time_value', parseInt(value) || 10);
    onFormChange('response_time_unit', 'seconds');
  };

  return (
    <form action="" className="w-full flex pb-8 flex-col gap-5 p-1 md:p-2">
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="name" className="font-medium text-[#0F172A] dark:text-[#FAFAFA]">Nome do assistente</Label>
        <Input
          placeholder="Name"
          id="name"
          value={formData.name || ''}
          onChange={(e) => onFormChange('name', e.target.value)}
          className={`${fieldClass} !w-full text-[14px]`}
          type="text"
        />
      </div>
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="model" className="font-medium text-[#0F172A] dark:text-[#FAFAFA]">Modelo</Label>
        <Select key="model-select" value={formData.model} onValueChange={(value) => onFormChange('model', value)}>
          <SelectTrigger className={`w-full ${fieldClass}`}>
            <SelectValue placeholder="Selecione um modelo" />
          </SelectTrigger>
          <SelectContent className="bg-white border-[#E5E7EB] dark:bg-[#27272A] dark:border-[#3F3F46]">
            <SelectGroup>
              {ModalOptions.map((item, index) => {
                return (
                  <SelectItem key={`model-${index}-${item.value}`} value={item.value}>
                    {item.label}
                  </SelectItem>
                );
              })}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="time-to-respond" className="font-medium text-[#0F172A] dark:text-[#FAFAFA]">Tempo para responder (segundos)</Label>
        <div className="flex items-center gap-3">
          <Select key="time-select" value={formData.response_time_value?.toString()} onValueChange={handleTimeValueChange}>
            <SelectTrigger className={`w-24 ${fieldClass}`}>
              <SelectValue placeholder="10" />
            </SelectTrigger>
            <SelectContent className="bg-white border-[#E5E7EB] dark:bg-[#27272A] dark:border-[#3F3F46]">
              <SelectGroup>
                {TimeToRespondSecondsOptions.map((item, index) => {
                  return (
                    <SelectItem key={`time-${index}-${item}`} value={item}>
                      {item}s
                    </SelectItem>
                  );
                })}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <p className="text-xs text-[#64748B] dark:text-[#71717A]">
          Tempo de espera para agregar mensagens antes de processar. Útil quando usuários enviam múltiplas mensagens seguidas.
        </p>
      </div>
      <div className="flex w-full flex-col items-start gap-2 pt-1">
        <div className="flex w-full items-start gap-3">
          <Switch
            id="disable-assistant-on-manual-message"
            className="mt-0.5 shrink-0"
            checked={formData.disable_assistant_on_manual_message ?? false}
            onCheckedChange={(checked) =>
              onFormChange("disable_assistant_on_manual_message", checked)
            }
          />
          <div className="flex flex-col gap-1 min-w-0">
            <Label
              htmlFor="disable-assistant-on-manual-message"
              className="text-sm font-medium text-[#0F172A] leading-snug cursor-pointer dark:text-[#FAFAFA]"
            >
              Desativar assistente ao enviar uma mensagem Manual
            </Label>
            <p className="text-[11px] leading-relaxed text-[#64748B] dark:text-[#71717A]">
              As mensagens manuais são enviadas via WhatsApp App, Web e dentro do Chat.
            </p>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ConfigureTab;

export const ModalOptions = [
  { value: "gpt-4o", label: "GPT-4o" },
  { value: "gpt-5", label: "GPT-5" },
  { value: "gpt-5.5", label: "GPT-5.5" },
  { value: "gpt-5.4-mini", label: "GPT-5.4 mini" },
  { value: "gpt-5.4-nano", label: "GPT-5.4 nano" },
];

export const TimeToRespondSecondsOptions = [
  "1",
  "2",
  "3",
  "5",
  "10",
  "15",
  "20",
  "30",
  "45",
  "60",
];

export const MaximumMessagesOptions = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "10",
  "30",
  "60",
];
